import CapacityCard from './capacity-card-view';

export default CapacityCard;
